window.objCopy = function (source, destiny) {
  for (var i in destiny) {
    delete destiny[i];
  }
  for (var i in source) {
    destiny[i] = source[i];
  }
};

// const colors = ['#8e44ad','#2ecc71','#c0392b', '#9b59b6', '#34495e', '#16a085', '#27ae60', '#2980b9', '#e67e22', '#2c3e50', '#f1c40f', '#1abc9c', '#e74c3c', '#f39c12', '#d35400', '#3498db', '#7f8c8d','#8e44ad','#2ecc71','#c0392b', '#9b59b6', '#34495e', '#16a085', '#27ae60', '#2980b9', '#e67e22', '#2c3e50', '#f1c40f', '#1abc9c', '#e74c3c', '#f39c12', '#d35400', '#3498db', '#7f8c8d'];

const colors = ['#7123DB', '#00ECA2', '#F60454', '#FF7F00', '#FF00FF', '#137AEE', '#00D5DD', '#00B9FF', '#00CE5B', '#FFC500', '#B700E9', '#0022B2', '#FFF500', '#98FF2F', '#7A009F', '#D60000', '#DA88FF', '#DD8800', '#3D5C45', '#00F5FF', '#B2A0FF', '#7E003F', '#00B2A4', '#33002F', '#0E4C79', '#0027FF', '#43007C', '#FFB688', '#96625C', '#7680A0', '#C698B4', '#FFA0D3', '#52335A'];

window.colorFromString = function (string) {
  if (typeof string == 'string') {
    const text = string.toUpperCase().replace(/([^A-Z])/g, '');

    if (text != '') {
      const index = Math.floor((text.charCodeAt(0) + text.charCodeAt(text.length - 1)) / 2 - 65);

      return colors[index];
    }
  }

  return colors[0];
};

const hasPlaceholder = [
  'text',
  'email',
  'textarea',
];

window.toBeeForm = ({
  name, description, hashid, price, button, action, action_content, id, hide_labels,
}, questions, page) => {
  const beeForm = questions.reduce((data, {
    name, type: fieldType, question, options, placeholder, mask, rules,
  }) => {
    /**
     * Force type email
     */
    const type = name && ['email', 'e-mail'].includes(name.toLowerCase())
      ? 'email'
      : fieldType;

    const field = {
      type,
      options: [],
      label: hide_labels ? '' : question,
      canBeRemovedFromLayout: false,
      attributes: {
        name,
      },
    };

    if (hasPlaceholder.includes(type) && placeholder) {
      field.attributes.placeholder = placeholder;
    }

    if (options && options.length > 0) {
      field.options = options.map(({ option }) => ({
        value: option,
        label: option,
        type: 'option',
      }));

      if (placeholder && type === 'select') {
        field.options.unshift({
          value: '',
          label: placeholder,
          type: 'option',
        });
      }
    }

    if (type === 'checkbox') {
      field.attributes.required = rules && rules.includes('required');
    } else if (type !== 'checkbox' && rules) {
      field.attributes.required = true;
    }

    if (field.attributes.required === null) {
      field.attributes.required = false;
    }

    if (mask) {
      field.attributes.itemid = mask;
    }

    data.layout.push([name]);

    data.fields[name] = field;

    console.log({
      name, placeholder, question,
    })

    if (name === 'consent-term') {
      if (placeholder !== null && placeholder !== undefined) {
        data.fields[name].label = `${placeholder} ${question}`;
      } else {
        data.fields[name].label = `${question}`;
      }
    }

    return data;
  },
  {
    title: name || '',
    description: description || '',
    attributes: {
      method: 'post',
      action: '',
      dir: price ? hashid || '' : '',
    },
    fields: {
      submit: {
        type: 'submit',
        canBeRemovedFromLayout: false,
        attributes: {
          'value': button || 'Enviar',
          'accesskey': `${name}`,
          'data-action': action || 'message',
          'data-callback': action_content || '',
          'data-sitekey': btoa(JSON.stringify({
            'bulldesk-form-id': `${id}`,
            'bulldesk-page-id': `${page}`,
            'hide_labels': hide_labels ? 'true' : 'false',
          })),
        },
      },
    },
    layout: [
      //
    ],
  });

  /**
   * Last on layout
   */
  beeForm.layout.push(
    ['submit'],
  );

  return {
    structure: beeForm,
  };
};
